import { render } from "./Content-editor.vue?vue&type=template&id=5e957d3b&scoped=true"
import script from "./Content-editor.vue?vue&type=script&lang=js"
export * from "./Content-editor.vue?vue&type=script&lang=js"

import "./contentEditorStyle.scss?vue&type=style&index=0&id=5e957d3b&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e957d3b"]])

export default __exports__